import React, { memo, useCallback } from 'react'

import Modal from 'Pods/Shared/Modal/Modal'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { closeSettingsModal, setSettingsModalTab } from 'Pods/ThreeDStudio/Store/actions/ui'
import { SETTINGS_MODAL_TAB } from 'Pods/ThreeDStudio/Store/constants'

import Nav, { panelDomId, tabDomId } from './Components/Nav/Nav'
import NotificationsTab from './Components/NotificationsTab/NotificationsTab'
import UsageTab from './Components/UsageTab/UsageTab'

function SettingsModal() {
  const t = useTranslation()
  const isOpen = useThreeDStudioStore(state => state.ui.isSettingsModalOpen)
  const activeTab = useThreeDStudioStore(state => state.ui.settingsModalTab)

  const handleClose = useCallback(() => {
    closeSettingsModal()
  }, [])

  if (!isOpen) {
    return null
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      width="medium"
      header={t('settingsModal.title')}
      customClass="settings-modal"
      ariaLabel={t('settingsModal.title')}
    >
      <div className="settings-modal__layout">
        <Nav activeTab={activeTab} onSelect={setSettingsModalTab} />
        <div
          className="settings-modal__content"
          role="tabpanel"
          id={panelDomId(activeTab)}
          aria-labelledby={tabDomId(activeTab)}
        >
          {activeTab === SETTINGS_MODAL_TAB.NOTIFICATIONS ? <NotificationsTab /> : <UsageTab />}
        </div>
      </div>
    </Modal>
  )
}

export default memo(SettingsModal)
